import * as React from 'react'
import { Text } from '@doordash/design-language'
import { SectionContainer, ContentText } from '../../../StyleComponents'
import { BikeSafetyTipsAndRoadRulesImage } from '../../../images'
import { ImageContainer, BulletList, BulletListItem } from '../../../styles'
import { LIST_ITEMS_1, LIST_ITEMS_2 } from './constants'
import { i18nKeys } from 'translationTypes'
import i18n from '../../../../../../i18n'

const stepName = 'SafetyTipsAndRoadRules'

export const SafetyTipsAndRoadRules = () => (
  <SectionContainer>
    <ImageContainer>
      <BikeSafetyTipsAndRoadRulesImage />
    </ImageContainer>
    <Text styles={Text.Styles.Bold32}>
      {i18n.t(
        i18nKeys.safetyCourse_bike_step2__au__heading__safetyTipsAndRoadRules
      )}
    </Text>
    <ContentText>
      {i18n.t(
        i18nKeys.safetyCourse_bike_step2__au__description__safetyTipsAndRoadRules
      )}
    </ContentText>

    <BulletList>
      {LIST_ITEMS_1.map((item, index) => (
        <BulletListItem key={`${stepName}_LIST_ITEMS_1_${index}`} mb="XSmall">
          <ContentText>{item}</ContentText>
        </BulletListItem>
      ))}
    </BulletList>

    <Text styles={Text.Styles.Bold32}>
      {i18n.t(
        i18nKeys.safetyCourse_bike_step2__au__heading__beingAwareOfCommonHazards
      )}
    </Text>

    <BulletList>
      {LIST_ITEMS_2.map((item, index) => (
        <BulletListItem key={`${stepName}_LIST_ITEMS_2_${index}`} mb="XSmall">
          <ContentText>{item}</ContentText>
        </BulletListItem>
      ))}
    </BulletList>
  </SectionContainer>
)
